<template>
  <AppMainSearchCard
    :tituloTela="tituloTela"
    :isLoading="isLoadingFabricasRacao"
    @add="$router.push({ path: '/fabricaRacao' })"
  >
    <v-layout wrap row justify-center>
      <v-flex class="item" xs11 md11 lg11 pb-2>
        <v-text-field
          v-model="search"
          append-icon="fas fa-search"
          label="Pesquise por Identificador, Nome ou CNPJ"
          single-line
          hide-details
          outlined
          clearable
        ></v-text-field>
      </v-flex>
    </v-layout>

    <v-layout row wrap justify-center pa-3>
      <v-flex class="item" sm12 xs12 md12 lg12>
        <v-data-table
          :headers="headers"
          :search="search"
          @click:row="editItem"
          no-results-text="Nenhum registro encontrado"
          :loading="isLoadingFabricasRacao"
          :must-sort="true"
          :items="fabricasRacao"
          color="secondary"
          loading-text="Carregando registros...aguarde"
        ></v-data-table>
      </v-flex>
    </v-layout>
  </AppMainSearchCard>
</template>

<script>
import AppMainSearchCard from "@/components/layout/AppMainSearchCard.vue";
import { formatCNPJ } from "@/filters/utils";

const toFabricaView = (entry) => {
  let nrCnpj = formatCNPJ(entry.nrCnpj);
  return { ...entry, nrCnpj };
};

export default {
  components: {
    AppMainSearchCard,
  },
  data: () => ({
    rowsPerPageItems: [5, 10, 15],
    pagination: { sortBy: "idFabricaRacao", descending: true, rowsPerPage: 5 },
    tituloTela: "Pesquisa de Fábricas de Ração",
    registroSelected: "",
    headers: [
      { text: "Identificador", value: "idFabricaRacao" },
      { text: "Nome", value: "nmFabricaRacao" },
      { text: "CNPJ", value: "nrCnpj" },
    ],
    fabricasRacao: [],
    isLoadingFabricasRacao: false,
    isErrorFabricaRacao: false,
    query: {},
    search: "",
  }),
  methods: {
    formatCNPJ,
    initViewFromRoute(route) {
      this.query = Object.assign({}, route.query);
      this.searchItem();
    },
    editItem(value) {
      this.$router.push({
        name: "fabricaRacao",
        params: { id: value.idFabricaRacao },
      });
    },
    searchItem() {
      var search = Object.assign({}, this.query);

      this.isLoadingFabricasRacao = true;

      this.$axios
        .get("fabrica-racao/", { params: search })
        .then((response) => {
          let records = response.data[0].data;

          this.fabricasRacao = records ? records.map(toFabricaView) : [];
        })
        .catch((error) => {
          this.isErrorFabricaRacao = true;
          this.$store.commit("setSnack", { type: "error", msg: error });
        })
        .finally(() => {
          this.isLoadingFabricasRacao = false;
        });
    },
    routeUpdate() {
      this.$router.push({ path: "fabricaRacaoSearch", query: this.query });
    },
  },
  mounted() {
    this.initViewFromRoute(this.$route);
  },
  watch: {
    options: {
      handler() {
        this.searchItem();
      },
      deep: true,
    },
  },
  beforeRouteUpdate(to, from, next) {
    this.initViewFromRoute(to);
    next();
  },
};
</script>

<style scoped>
.item {
  margin: 1px;
}
</style>
